import { useId } from "react"
import cn from "@/v1-ui/utils/utils.cn"
import Frame, { type FrameContainerProps } from "@/v1-ui/Frame"
import useDraggable from "./dialog2.draggable"

export type Dialog2ContainerProps = FrameContainerProps & {
  hasBackdrop?: boolean,
  isAnchored?: boolean,
  isDraggable?: boolean,
  isResizable?: boolean
}

/**
 * This component is not exposed as part of the public API
 */
function Dialog2Container(props: Dialog2ContainerProps) {
  const {
    id,
    className,
    hasBackdrop = true,
    isAnchored = false,
    isDraggable = false,
    isResizable = false,
    onMouseUp,
    ...frameContainerProps
  } = props

  const rId = useId()
  const _id = id || rId

  useDraggable(_id, isDraggable, hasBackdrop)

  return (
    <Frame.Container
      role="dialog"
      id={_id}
      className={cn("dialog2", className, {
        "dialog2-has-backdrop": hasBackdrop,
        "dialog2-has-no-backdrop": !hasBackdrop,
        "dialog2-is-anchored": isAnchored,
        "dialog2-is-draggable": isDraggable,
        "dialog2-is-resizable": isResizable
      })}
      onMouseUp={isDraggable
        ? null
        : onMouseUp
      }
      {...frameContainerProps}
    />
  )
}

export default Dialog2Container
